import options from './radio-ccon.component';

export default {
    selector: 'dtRadioStatusCcon',
    options
};
